import {
  useTheme,
  Box,
  Typography,
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

const whatsappLink = 'https://api.whatsapp.com/send?phone=5543996823513';

const FaqGrid = () => {
  const theme = useTheme();
  const faqList = [
    {
      id: 1,
      question:
        'Como faço para escolher o seguro ideal para as minhas viagens?',
      answer: (
        <label>
          Escolher o seguro ideal faz parte de um bom planejamento de viagem.
          Para garantir que você faça uma boa escolha e tire todas as suas
          dúvidas, disponibilizamos nosso atendimento pelo WhatsApp para te
          auxiliar.
          <br />
          <br />
          Entre em contato agora mesmo{' '}
          <b>
            <a
              href={whatsappLink}
              target="_blank"
              rel="noreferrer"
              style={{ color: theme.palette.text.secondary }}
            >
              clicando aqui
            </a>
          </b>{' '}
          e fale com nosso atendimento!
        </label>
      ),
    },
    {
      id: 2,
      question: 'Quais os tipos de cobertura do seguro viagem?',
      answer: (
        <label>
          As coberturas do seu seguro viagem vão variar de acordo com a
          seguradora escolhida, entretanto algumas das coberturas comuns são:
          <br />
          <br /> - Assistência Médica e Hospitalar
          <br /> - Assistência Odontológica
          <br /> - Assistência Farmacêutica
          <br /> - Regresso Sanitário
          <br /> - Traslado Médico
          <br /> - Seguro bagagem
          <br /> - Despesas Jurídicas
        </label>
      ),
    },
    {
      id: 3,
      question: 'Por que escolher meu Seguro Viagem com a Assegurados?',
      answer: (
        <label>
          Nosso principal objetivo é que você possa fazer sua viagem de forma
          tranquila e, caso precise acionar seu seguro, que você não fique na
          mão! Por isso escolhemos trabalhar com os melhores seguradoras, de
          forma a garantir que você sempre esteja bem amparado.
          <br />
          <br /> Atualmente trabalhamos com as seguradoras listadas abaixo:
          <br />
          <br /> - Universal Assistance
          <br /> - Assist Card
          <br /> - Affinity Seguro Viagem
          <br /> - Coris Seguro Viagem
        </label>
      ),
    },
    {
      id: 4,
      question: 'Como devo proceder caso precise acionar meu seguro viagem?',
      answer: (
        <label>
          Ao fechar o seu seguro, você irá receber uma apólice. Nesse documento
          constam todos os dados do seguro contratado, bem como os telefones e
          contatos da seguradora.
          <br />
          <br />
          Todas seguradoras possuem um atendimento 24hr, e algumas delas possuem
          outros canais de atendimento como Skype, WhatsApp e até aplicativo
          próprio.
        </label>
      ),
    },
    {
      id: 5,
      question: 'O que é o Tratado de Schengen?',
      answer: (
        <label>
          O Tratado de Schengen se trata de um acordo entre países Europeus que
          permite que turistas brasileiros possam circular pelos países que
          fazem parte do acordo por um período de 90 dias sem a necessidade de
          visto.
          <br />
          <br />
          Para isso, os países exigem que os turistas tenham um Seguro Viagem
          com cobertura mínima de 30 mil euros.
        </label>
      ),
    },
    {
      id: 6,
      question:
        'Como funciona o processo de cotação e compra do meu seguro viagem com a Assegurados?',
      answer: (
        <label>
          O processo é bem simples, basta entrar em contato com o nosso
          atendimento{' '}
          <b>
            <a href={whatsappLink} target="_blank" rel="noreferrer">
              clicando aqui
            </a>
          </b>{' '}
          e passar alguns dados básicos da sua viagem.
          <br />
          <br />
          Após isso, nosso atendimento vai te apresentar as melhores coberturas
          e preços! Basta escolher o que te agrada, fazer o pagamento e pronto!
          <br />
          <br />
          Você receberá a sua apólice por e-mail e por WhatsApp.
        </label>
      ),
    },
  ];

  return (
    <Box
      sx={{
        width: '100%',
        margin: '0 auto',
        maxWidth: 'lg',
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        gap: theme.spacingValues.large,
      }}
    >
      {/* Left Section */}
      <Box
        sx={{
          flex: { xs: '1 1 100%', md: '1 1 50%' },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: { xs: 'center', md: 'flex-start' },
          }}
        >
          <Box
            sx={{
              backgroundColor: theme.palette.primary.contrastText,
              borderRadius: theme.spacingValues.large,
              padding: `${theme.spacingValues.small} ${theme.spacingValues.medium}`,
              width: 'fit-content',
            }}
          >
            <Typography sx={{ color: theme.palette.primary.main }}>
              FAQ
            </Typography>
          </Box>
          <Typography
            variant="h3"
            sx={{
              maxWidth: '500px',
              marginTop: theme.spacingValues.medium,
              textAlign: 'center',
            }}
          >
            <span style={{ color: theme.palette.primary.main }}>Dúvidas</span>{' '}
            Frequentes
          </Typography>
        </Box>
      </Box>

      {/* Right Section */}
      <Box
        sx={{
          flex: { xs: '1 1 100%', md: '1 1 50%' },
        }}
      >
        <Stack spacing={1}>
          {faqList.map((faq) => (
            <Accordion
              key={faq.id}
              sx={{
                borderRadius: '16px !important', // Override default Material-UI styles
                '&:before': {
                  display: 'none', // Removes the default divider
                },
                '& .MuiAccordionSummary-root': {
                  borderRadius: '16px',
                },
                // Maintain border radius when expanded
                '&.Mui-expanded': {
                  borderRadius: '16px',
                },
                // Fix for last child border radius
                '&:last-of-type': {
                  borderRadius: '16px',
                },
              }}
            >
              <AccordionSummary
                expandIcon={
                  <ExpandMore sx={{ color: theme.palette.primary.main }} />
                }
                aria-controls={`panel-${faq.id}-content`}
                id={`panel-${faq.id}-header`}
                sx={{
                  borderRadius: '16px',
                  '&.Mui-expanded': {
                    borderRadius: '16px 16px 0 0', // Round only top corners when expanded
                  },
                }}
              >
                <Typography variant="body1" sx={{ fontWeight: 'bolder' }}>
                  {faq.question}
                </Typography>
              </AccordionSummary>
              <Divider
                sx={{
                  borderColor: 'black',
                  display: 'block',
                  width: '95%',
                  margin: '0 auto',
                  transform: 'translateY(-10px)',
                }}
              />
              <AccordionDetails>
                <Typography variant="body2">{faq.answer}</Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Stack>
      </Box>
    </Box>
  );
};

export default FaqGrid;
